import { useUpdateGoalSortModeMutation } from 'shared/hooks/queries/use-update-goal-sort-mode-mutation';

export const useUpdateGoalSortMode = () => {
  const { mutate } = useUpdateGoalSortModeMutation();

  return mutate;
};
